import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 12 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 20\" id=\"icon-arrow-right\">\r\n  <path id=\"icon-arrow-right_Path\" d=\"M11.674,9.22,2.584.32A1.137,1.137,0,0,0,1,.32L.335.975a1.079,1.079,0,0,0,0,1.547L7.968,10,.326,17.478a1.08,1.08,0,0,0,0,1.547L1,19.68a1.137,1.137,0,0,0,1.58,0l9.1-8.908a1.088,1.088,0,0,0,0-1.553Z\" fill=\"#a6291a\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol